<template>
  <div class="collapser" @click="onCardToggle('collapser')">
    <div class="collapser__header" @click="onCardToggle">
      <div class="collapser__header__left-block">
        <slot name="collapser-header-content"></slot>
      </div>
      <div class="collapser__header__right-block">
        <span v-if="!expanded" class="mi-24px mi-chevron-down"></span>
        <span v-else class="mi-24px mi-chevron-up"></span>
      </div>
    </div>
    <slot v-if="expanded" name="collapser-body"></slot>
  </div>
</template>

<script>
export default {
  name: "Collapser",
  props: {
    expanded: { type: Boolean, default: false },
    background: { type: String, default: "var(--Gray-100)" },
    item: { type: Object, default: null },
    index: { type: Number, default: null },
    noBodyToggle: { type: Boolean, default: false },
  },
  methods: {
    onCardToggle(origin) {
      if (origin === "collapser" && this.noBodyToggle) return false;
      this.$emit("onCardToggle", this.item, this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";
.collapser {
  &__header {
    background: var(--v2-bg-color);
    border-radius: 0.25rem;
    padding: 1rem;
    margin-left: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include media("<tablet") {
      margin-left: 40px;
    }

    &__left-block {
      display: flex;
      align-items: center;

      @include media("<tablet") {
        flex-direction: column;
      }
    }
  }
}
</style>